/**
 * Sonni minglik bo'shliq bilan formatlaydi: 10000 -> "10 000"
 * Manfiy son, kasr son va bo'sh qiymatlarni ham to'g'ri ishlaydi.
 */
export function formatMoney(value) {
    if (value === null || value === undefined || value === '') return ''
    const str = String(value).replace(/\s/g, '')
    const num = Number(str)
    if (isNaN(num)) return value
    const parts = str.split('.')
    const intPart = parts[0].replace(/^(-?)(\d+)$/, (m, sign, digits) => {
        return sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    })
    return parts.length > 1 ? `${intPart}.${parts[1]}` : intPart
}
